import { render, staticRenderFns } from "./SmeDetailedTable.vue?vue&type=template&id=6e08e0b2&scoped=true&"
import script from "./SmeDetailedTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./SmeDetailedTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SmeDetailedTable.vue?vue&type=style&index=0&id=6e08e0b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e08e0b2",
  null
  
)

export default component.exports